module.exports = __webpack_public_path__ + "img/bg-cy.0ed20531.png";